import {ValueDefinition} from '@/model/types';

export enum Guarantees {
  _75_100 = 'DV-88#0',
  _75_100_enriched = 'DV-88#1',
  Basic = 'DV-88#2',
  Enhanced = 'DV-88#3',
  Optimal = 'DV-88#4',
  Standard = 'DV-88#5',
  Premium = 'DV-88#6',
  CIG_40 = 'DV-88#7',
  CIG_60 = 'DV-88#8',
}

export const DV_88 = {
  id: 'DV-88',
  description: {
    fr: 'Type de garantie',
    en: 'Guarantee type',
  },
  type: 'GuaranteeType',
  values: [
    {
      id: '0',
      value: {
        fr: 'Garantie 75/100',
        en: '75/100 guarantee',
      },
      properties: {
        id_beneva: 'F',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Garantie 75/100 enrichie',
        en: '75/100 enhanced guarantee',
      },
      properties: {
        id_beneva: 'P',
      },
    },
    {
      id: '2',
      value: {
        fr: 'Régulière (75/75)',
        en: 'Basic (75/75)',
      },
      properties: {
        id_beneva: 'A',
      },
    },
    {
      id: '3',
      value: {
        fr: 'Enrichie (75/100)',
        en: 'Enhanced (75/100)',
      },
      properties: {
        id_beneva: 'B',
      },
    },
    {
      id: '4',
      value: {
        fr: 'Optimale (100/100)',
        en: 'Optimal (100/100)',
      },
      properties: {
        id_beneva: 'C',
      },
    },
    {
      id: '5',
      value: {
        fr: 'Ancienne de Base (75/100)',
        en: 'Old Standard (75/100)',
      },
      properties: {
        id_beneva: '3',
      },
    },
    {
      id: '6',
      value: {
        fr: 'Ancienne Supérieure (100/100)',
        en: 'Old Premium (100/100)',
      },
      properties: {
        id_beneva: '4',
      },
    },
    {
      id: '7',
      value: {
        fr: 'CIG Boursier (40% Fonds)',
        en: 'Equity GIA (40% Fund)',
      },
      properties: {
        id_beneva: 'D',
      },
    },
    {
      id: '8',
      value: {
        fr: 'CIG Boursier (60% Fonds)',
        en: 'Equity GIA (60% Fund)',
      },
      properties: {
        id_beneva: 'E',
      },
    },
  ],
} as const satisfies ValueDefinition;
